import React from 'react';
import { Container, Menu, Segment, Grid, Header, Image, Icon, Button, Form, Divider } from 'semantic-ui-react'

export default class ArdaAuthWrapper extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {}
    
    render() {
        return (
            <Container fluid>
                <Container>
                    <Segment basic textAlign="center">
                        <Divider />
                        <Image href='/' size="large" src='/images/bigscreen_logo_black_no_margin.png' /><br />
                        <Segment basic>
                            {this.props.children}
                        </Segment>
                    </Segment>
                </Container>
            </Container>
        );
    }
}

